import React, { FC, createContext, useContext } from 'react';

export type StoreHandler = {
	set: <T = string>(key: string, value: T | null) => void,
	get: <T = string>(key: string) => T | null,
	clear: (key: string) => void,
}

const CommonStoreContext = createContext<StoreHandler>({
	set: () => {},
	get: () => null,
	clear: () => {},
});

interface Props {
	storeHandler: StoreHandler,
}
export const CommonStoreProvider: FC<Props> = ({ storeHandler, children }) => (
	<CommonStoreContext.Provider value={storeHandler}>
		{ children }
	</CommonStoreContext.Provider>
)

export const useCommonStore = () => useContext(CommonStoreContext);